import { render, staticRenderFns } from "./form-brief.vue?vue&type=template&id=981cb44e&"
import script from "./form-brief.vue?vue&type=script&lang=js&"
export * from "./form-brief.vue?vue&type=script&lang=js&"
import style0 from "./form-brief.vue?vue&type=style&index=0&id=981cb44e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports